import { selector } from 'recoil';
import { opcInfoAtom } from '../atoms/opcInfoAtom';

export const isOpcDataFilledSelector = selector<boolean>({
    key: 'isOpcDataFilledSelector',
    get: ({ get }) => {
        const opcInfo = get(opcInfoAtom);
        const { tilpas, adjustAction } = opcInfo;
        if (tilpas === 'tilfoej' || (tilpas === 'tilpas' && adjustAction !== 'Limit')) {
            return true;
        }
        return false;
    }
});
